module.exports = __webpack_public_path__ + "static/img/one-2.e5c43e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/one-2.png
// module id = tVWA
// module chunks = 1